<template>
  <UsersList/>
</template>
<script>
import UsersList from '@/components/modules/admin/users/list'
export default {
  name: 'users',
  components: {
    UsersList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/users/list.vue